import styled from 'styled-components';

export const InputSelectContainer = styled.div`
  margin-bottom: 8px;
`;
export const InputSelectWrapper = styled.div``;

export const ErrorContent = styled.span`
  color: ${props => props.theme.colors.error1};
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
`;
